import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface FileAttachments {
    [key: string]: string;
}

export interface ReturnRMAData {
    attachment?: FileAttachments;
    RMAdata: Partial<ReturnItemsApiParameters>;
}

export interface ReturnItemsApiParameters {
    InvoiceNo?: string;
    TrackingNo?: string;
    InvoiceDate?: string;
    PoNumber?: string
    ReturnItems?: ReturnItemParams[];
    returnNotes?: string;
}

export interface ReturnItemParams {
    ItemCode?: string;
    SalesOrderNo?: string;
    QuantityReturned?: number;
    ReturnReasonCode?: string;
    UDFReasonDescription?: string;
    ProblemType?: string;
    Comments?: string;
    InvoiceNo?: string;
    UnitCreditAmount?: number;
    AttachmentNames?: Attachmentdata[];
    SourceBrand?: string;
}

export interface Attachmentdata {
    fileName: string;
    azureUrl: string;
}

const returnUrl = "/api/v2/returns";

export interface RMAModel {}

export function CustomRMAService(parameter: ReturnRMAData) {
    const formData = new FormData();
    // Object.entries(parameter?.attachment!).forEach(([key, value], index) => {
    //     formData.append(`attachment${index + 1}`, value);
    // });
    formData.append("RMAdata[]", JSON.stringify(parameter.RMAdata));
    return request<ServiceResult<RMAModel>>(returnUrl, "POST", {}, formData);
}
